import React, { 
    useState,
    useEffect, 
} from 'react';
import Navbar from '../../Components/Navbar/Navbar'
import { 
    Calendar, 
    Badge, 
    Layout,
    Row,
    Col, 
} from "antd";
import { formatDate, formatDateTime } from "../../Utils/Common";
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import dayjs from "dayjs";

const TaskCalendar = () => {  
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    // const [isLoading, setIsLoading] = useState(false);

    const [filterConfig, setFilterConfig] = useState({
        month: dayjs().format("MM"),
        year: dayjs().format("YYYY"),
    });
    const [managerData, setManagerData] = useState([])
    
    async function fetchTaskManagerData  () {
        // setIsLoading(true)
        const response = await UseGetRequest("task_managers/get", filterConfig);
        if (response?.data) {
            const data = response?.data?.data?.map((info) => ({
                ...info,
                due_date: formatDate(info.due_date),
                type: info.status === 'done' ? 'success' : 
                        info.status === 'in-progress' ? 'processing' :
                            info.status === 'to do' ? 'warning' :  'error'
            }))
            setManagerData(data);
        } else {
            setManagerData([])
        }
        // setIsLoading(false);
    }
    
    const dateRender = (value) => {
        const formattedDate = value.format("YYYY-MM-DD");
    
        const listData = managerData.filter((event) => event.due_date === formatDate(formattedDate));

        return (
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {listData.map((item, index) => (
                    <li key={index}>
                        <Badge status={item.type} text={item.summary} />
                    </li>
                ))}
            </ul>
        );
    };
    const monthRender = (value) => {
        const listData = managerData.filter((event) => 
            dayjs(event.due_date).month() === value.month()
        );

        return (
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {listData.map((item, index) => (
                <li key={index}>
                    <Badge status={item.type} text={item.summary} />
                </li>
            ))}
            </ul>
        );
    };

    const handleDate = (data, type) => {
        if(type === 'month'){
            setFilterConfig((prev) => (
                {
                  ...prev,
                  year: data.format("YYYY") || '',
                  month: data.format("MM") || '',
                }
            ));
        } else {
            setFilterConfig((prev) => (
                {
                  ...prev,
                  month: '',
                  year: data.format("YYYY") || '',
                }
            ));
        }
    }

    useEffect(() => {
        fetchTaskManagerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);

    useEffect(() => {
        const intervalId = setInterval(() => {
          setCurrentDateTime(new Date());
        }, 1000);
    
        // Clear the interval when the component unmounts or when the dependency array changes
        return () => clearInterval(intervalId);
    }, []);

    return (
        <Layout className='page'>
            <Navbar navKey={'task_calendar_nav'}/>
            <Layout className='content-container overflow-y'>
               <Row className='p-4'>
                    <Col span={24}>
                        <Row>
                            <Col 
                                span={24}
                                className='header-container-date resp-header'
                            >
                                {formatDateTime(currentDateTime)}
                            </Col>
                        </Row>
                        <Row>
                            <Col 
                                span={24}
                            >
                                <Calendar 
                                    dateCellRender={dateRender} 
                                    monthCellRender={monthRender}
                                    onPanelChange={handleDate} 
                                />
                            </Col>
                        </Row>
                    </Col>
               </Row>
            </Layout>
        </Layout>
    );
};

export default TaskCalendar;
